
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import api from "@/services/api.service";
import { PasswordModel } from "@/store/my-account/types";
import { PasswordChangeResult } from "@/store/user-management/types";
import { FeaturesList } from "@/store/types";
import { get } from "lodash";
import { BModal } from "bootstrap-vue";
import AccountDetails from "./account-details.vue";

const UserManagement = namespace("userManagement");

@Component({
	components: {
		"account-details": AccountDetails
	}
})
export default class MyAccount extends Vue {
	@Getter("getFeaturesList") featuresList: FeaturesList;

	private showAccountDetails: boolean = false;

	// If feature is on / off
	public get IsAccountDetailsEnabled() {
		return get(this.featuresList, ["AccountDetails"]);
	}
}
